import * as React from "react";
import { LineItemDeleteButton } from "@grandvisionhq/common";
import { useRemoveFromCart } from "../../../../../../hooks/hooks/use-remove-from-cart.js";
const RemoveLineItemContainer = ({ lineItem }) => {
  const [removeFromCart] = useRemoveFromCart(lineItem);
  const handleOnClick = React.useCallback(() => {
    removeFromCart();
  }, [removeFromCart]);
  return /* @__PURE__ */ React.createElement(LineItemDeleteButton, { onClick: handleOnClick });
};
export {
  RemoveLineItemContainer
};
//# sourceMappingURL=RemoveLineItemContainer.js.map
